var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraidentSubscription2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1228,
    height: 695,
    viewBox: "0 0 1228 695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8765_16802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.824 722.287L400.673 622.946C720.464 624.286 1119.89 524.642 1109.71 400.571L1365.76 401.644C1380.43 580.507 869.763 724.219 408.824 722.287Z",
    fill: "url(#paint0_linear_8765_16802)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8765_16802",
    x: 0.673096,
    y: 0.570801,
    width: 1765.39,
    height: 1121.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_8765_16802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8765_16802",
    x1: 543.021,
    y1: 560.33,
    x2: 1373.16,
    y2: 492.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#611C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202D4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraidentSubscription2);
export default __webpack_public_path__ + "static/media/graident_subscription_2.b244fd33997376622ec397dbf568ff59.svg";
export { ForwardRef as ReactComponent };